import { Typography } from '@mui/material';
import UploadList from 'lib/common/UploadList';
import { hasAnyPermissions } from 'lib/functions/utils';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AuthState } from 'services/redux/authSlice';

const ProfileCompliance = () => {
  const { id } = useParams<{
    id: string;
    businessId: string;
    page: string;
  }>();

  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const canUpload = hasAnyPermissions(user, [
    'business_can_upload_compliance_files',
  ]);

  const canDownload = hasAnyPermissions(user, [
    'business_can_download_compliance_files',
  ]);

  return (
    <div>
      <div
        style={{
          paddingTop: 20,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <Typography variant="body1">
            Estos son los documentos que ha subido el cliente
          </Typography>
        </div>
      </div>
      <UploadList
        products={['UAF', 'PEP']}
        requestType={`Clients,${id},Compliance`}
        canDownload={canDownload}
        canUpload={canUpload}
      />
    </div>
  );
};

export default ProfileCompliance;
